export type DeviceType = 'mobile' | 'computer_narrow' | 'computer';

/** Below this width the dashboard shows its "please use a wider screen" warning. */
const MINIMUM_SUPPORTED_SCREEN_WIDTH = 1050;

const isMobileUserAgent = (): boolean => {
	const userAgentString = navigator.userAgent;
	return /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgentString);
};

/**
 * The kind of device the visitor is currently browsing on. Recorded against the user in Intercom at
 * sign up so outgoing email campaigns can be filtered by device type.
 */
export const currentDeviceType = (): DeviceType => {
	if (isMobileUserAgent()) {
		return 'mobile';
	} else if (window.innerWidth < MINIMUM_SUPPORTED_SCREEN_WIDTH) {
		return 'computer_narrow';
	} else {
		return 'computer';
	}
};
